import { EntityTypes, RichEditorVariable } from '../types';
import { RawDraftContentState, convertFromRaw } from 'draft-js';
import { findVariable } from '../utils';
import { stateToHTML } from 'draft-js-export-html';

const VariableTagRegex = /<span data-variable-value="([^"]*)">([^<]*)<\/span>/g;

export const convertDraftToHTML = (rawContent: RawDraftContentState, variables?: RichEditorVariable[]): string => {
    let html = stateToHTML(convertFromRaw(rawContent), {
        entityStyleFn: (entity) => {
            const entityType = entity.getType();

            if (entityType === EntityTypes.Variable) {
                const data: RichEditorVariable = entity.getData();
                const foundVar = Array.isArray(data.name)
                    ? data.name.map((name) => findVariable(name, variables)).find((variable) => Boolean(variable))
                    : findVariable(data.name, variables);
                return {
                    element: 'span',
                    attributes: {
                        'data-variable-value': foundVar?.value ?? '',
                    },
                };
            }

            return undefined;
        },
    });

    // lbento: There's a limitation here that I can style the variable
    // however I want, but I can't replace the text (the variable display
    // name) with the actual variable value.
    // To get around this I instead wrap the variable display name with
    // a `<span>` containing the variable value as a `data-variable-value`
    // attribute. Then I do another pass replacing the whole `<span>` with
    // whatever text is in `data-variable-value`.
    // It's a bit hacky, but does the job for now. I'll try to dig deeper
    // and see if I can find another package or a better way to parse it.

    let matchArr;
    while ((matchArr = VariableTagRegex.exec(html)) !== null) {
        const fullMatch = matchArr[0];
        const variableValue = matchArr[1];
        const variableDisplay = matchArr[2];

        if (fullMatch) {
            if (variableValue) {
                html = html.replace(fullMatch, variableValue);
            } else if (variableDisplay) {
                html = html.replace(fullMatch, variableDisplay);
            }
            // we changed the html content, so we need to restart search from the
            // beginning of the string.
            VariableTagRegex.lastIndex = 0;
        }
    }

    return html;
};
